import { useEffect } from "react";
import Button from "components/Button";
import { Link } from "react-router-dom";
import BackgroundSlider from "./BackgroundSlider";
import {
  REACT_APP_ASSETS_URL,
  REACT_APP_MAIANS_TWITTER_URL,
} from "constants/constant";
import "./style.css";

export default function ComingSoon() {
  return (
    <div className="comingsoon relative w-screen h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-screen">
        <BackgroundSlider />
      </div>
      <div className="relative flex flex-col gap-8 lg:gap-14 z-10">
        <div className="flex items-center">
          <h1 className="text-[34px] lg:text-4xl xl:text-[150px] font-bold font-serif leading-none tracking-tight text-white uppercase">
            coming soon!
          </h1>
          <img
            src={`${REACT_APP_ASSETS_URL}cs-char.webp`}
            alt="characters"
            className="relative -m-2 lg:-m-10 w-[40px] md:max-h-[150px] lg:max-h-[200px] object-contain md:w-[80px] lg:w-[100px]"
          />
        </div>

        <div className="relative flex items-center justify-center gap-2 lg:gap-4 z-10">
          <Link to="/">
            <Button
              className="primary-button p-[15px] lg:p-[24px]"
              leftIcon
              text="Go Back"
            />
          </Link>
          <Link to={`${REACT_APP_MAIANS_TWITTER_URL}`} target="_blank">
            <Button
              className="outline-button twitter p-[15px] lg:p-[24px] text-white border-0"
              text="Join Us on"
              twitterIcon
            />
          </Link>
        </div>
      </div>
    </div>
  );
}
